import { ChevronLeftIcon } from '@/shared/ui/icons/ChevronLeftIcon'
import { ChevronRightIcon } from '@/shared/ui/icons/ChevronRightIcon'
import type { RowCarousel } from '@/shared/composables/useRowCarousel'

export function CarouselArrows({
  control,
  label,
  top,
}: {
  control: RowCarousel
  label: string
  top: number
}) {
  return (
    <>
      <ArrowButton
        side="prev"
        label={`${label} 이전`}
        top={top}
        disabled={!control.canPrev}
        onClick={control.scrollPrev}
      />
      <ArrowButton
        side="next"
        label={`${label} 다음`}
        top={top}
        disabled={!control.canNext}
        onClick={control.scrollNext}
      />
    </>
  )
}

function ArrowButton({
  side,
  label,
  top,
  disabled,
  onClick,
}: {
  side: 'prev' | 'next'
  label: string
  top: number
  disabled: boolean
  onClick: () => void
}) {
  return (
    <button
      type="button"
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
      style={{ top }}
      className={[
        'ui-pressable ui-pressable--circle absolute z-[2] inline-flex h-12 w-12 cursor-pointer items-center justify-center',
        'rounded-[999px] border border-white-300 bg-white-50 p-0 text-black-600',
        'shadow-[0_2px_8px_rgb(0_0_0/8%)]',
        'disabled:cursor-default disabled:text-white-500 disabled:shadow-none',
        side === 'prev' ? '-left-6' : '-right-6',
      ].join(' ')}
    >
      {side === 'prev' ? <ChevronLeftIcon size={24} /> : <ChevronRightIcon size={24} />}
    </button>
  )
}
